<template>
    <!-- Template Switcher Logic -->
    <div v-if="isMember">
      <MemberTemplate @updateMembershipStatus="updateMembershipStatus" />
    </div>
    <div v-else>
      <NonMemberTemplate @updateMembershipStatus="updateMembershipStatus" />
    </div>

</template>

<script>
import MemberTemplate from './layouts/MemberTemplate.vue';
import NonMemberTemplate from './layouts/NonMemberTemplate.vue';

export default {
  name: 'App',
  components: {
    MemberTemplate,
    NonMemberTemplate
  },
  data() {
    return {
      isMember: this.getMemberStatusFromLocalStorage(), // Set to true for member, false for non-member
    };
  },
  created() {
      // console.log(this.$route.path)       // Current path
      // console.log(this.$route.name)       // Named route
      //this.$route.path
      this.updateMembershipStatus();
  },
  methods: {
    updateMembershipStatus() {
      this.isMember = this.getMemberStatusFromLocalStorage();
      // if(!this.isMember)
      //   this.$router.push('/login'); // Redirect to login
      // else
      //   this.$router.push('/dashboard');
    },
    getMemberStatusFromLocalStorage() {
      return localStorage.getItem('user') != undefined; // Ensure it's a boolean value
    },

  }
};
</script>

<style>

</style>